const ALIASES = {
  en:{"汉字":"Chinese Characters","汉字地图":"Chinese Character Map","荷花":"Lotus","荷花地图":"Lotus Map","暂无地图描述":"No map description"},
  de:{"汉字":"Chinesische Schriftzeichen","汉字地图":"Karte chinesischer Schriftzeichen","荷花":"Lotus","荷花地图":"Lotuskarte","暂无地图描述":"Keine Kartenbeschreibung"},
  ja:{"汉字":"漢字","汉字地图":"漢字マップ","荷花":"蓮","荷花地图":"蓮のマップ"},
  ko:{"汉字":"한자","汉字地图":"한자 지도","荷花":"연꽃","荷花地图":"연꽃 지도"}
};

export function localizedCreatorText(languageStore, value, kind = "description") {
  const text = String(value || "").trim();
  if (!text) return kind === "name" ? languageStore.t("custom") : languageStore.t("noMapDescription");
  const translated = ALIASES[languageStore.language]?.[text];
  if (translated) return translated;
  if (!languageStore.language.startsWith("zh") && /[\u3400-\u9fff]/u.test(text)) {
    return kind === "name" ? languageStore.t("custom") : languageStore.t("noMapDescription");
  }
  return text;
}
